import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Card,
  Typography,
  TextField,
  IconButton,
  Button,
  Avatar,
  useTheme,
  CardContent,
  InputAdornment,
} from "@mui/material";
import Webcam from "react-webcam";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import useIPAddress from "../Utils/useIPAddress";
import axios from "axios";
import { baseapi } from "../Environmentalurl";
import { entity_id, getGeolocation, location, Platform } from "../Utils/Const";
import { ArrowBackIosNewOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../Dashboard/DashboardHeader";
import api from "../Utils/Api";

export default function Citizeninfo() {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const [image, setImage] = useState(null);

  const [formData, setFormData] = useState({
    userName: "",
    mobileNumber: "",
    email: "",
    accountNumber: "",
    ifscCode: "",
    bankName: "",
    branchName: "",
    MMID: "",
    kycStatus: "",
    aadhaarStatus: "Aadhaar submitted successfully",
  });

  const ip = useIPAddress();
  const navigate = useNavigate();

  const webcamRef = useRef(null);
  const fileInputRef = useRef(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [openCamera, setOpenCamera] = useState(false);

  // Load photo from sessionStorage
  useEffect(() => {
    const storedImage = sessionStorage.getItem("userPhoto");
    if (storedImage) {
      setImage(storedImage);
    }
  }, []);

  // Fetch profile details from API
  useEffect(() => {
    if (!ip) return;

    const SessionID = sessionStorage.getItem("SessionID");
    const mobileNumber = sessionStorage.getItem("mobileNumber");

    if (!SessionID || !mobileNumber) return;

    const loadImage = async () => {
      try {
        const res = await api.get(`${baseapi}/image`, {
          params: { mobileNumber, entityId: entity_id },
          headers: { userSessionId: SessionID },
        });

        if (res.data?.Response_Code === "1000" && res.data?.ProfileURL) {
          setImage(res.data.ProfileURL); // ⭐ default image from server
        }
      } catch (err) {
        console.error("Image fetch error:", err);
      }
    };

    loadImage();
  }, [ip]);

  const handleAvatarClick = () => {
    setOpenDialog(true);
  };
  const uploadImage = async (file) => {
    const SessionID = sessionStorage.getItem("SessionID");
    const mobileNumber = sessionStorage.getItem("mobileNumber");

    if (!SessionID || !mobileNumber) return;

    const fd = new FormData();

    fd.append("file", file);
    fd.append("mobileNumber", mobileNumber);
    fd.append("entityId", entity_id);
    fd.append("userSessionId", SessionID);

    try {
      const res = await api.post(`${baseapi}/uploadprofile`, fd, {
        headers: {
          userSessionId: SessionID,
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data?.Response_Code === "1000") {
        const reader = new FileReader();

        reader.onload = () => {
          setImage(reader.result);
          sessionStorage.setItem("userPhoto", reader.result);
        };

        reader.readAsDataURL(file);
      }
    } catch (err) {
      console.error(err);
      alert("Image upload failed.");
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      uploadImage(file);
    }
  };
  const captureImage = async () => {
    try {
      const imageSrc = webcamRef.current?.getScreenshot();

      if (!imageSrc) {
        alert("Camera is not ready.");
        return;
      }

      // Close the camera dialog
      setOpenCamera(false);

      const blob = await fetch(imageSrc).then((r) => r.blob());

      const file = new File([blob], "profile.jpg", {
        type: "image/jpeg",
      });

      await uploadImage(file);
    } catch (error) {
      console.error(error);
      alert("Unable to capture image.");
    }
  };

  const fetchProfile = async () => {
    try {
      const SessionID = sessionStorage.getItem("SessionID");
      const mobileNumber = sessionStorage.getItem("mobileNumber");

      if (!SessionID || !mobileNumber) {
        navigate("/login");
        return;
      }

      const payload = {
        ReqType: "MT_User_ViewProfile",
        Mobilenumber: mobileNumber,
        SessionID: SessionID,
        Platform: Platform,
        GeoLocation: location,
        MachineID: ip,
        EntityID: entity_id,
      };

      const headers = {
        userSessionId: SessionID,
        "Content-Type": "application/json",
      };

      const response = await api.post(`${baseapi}/viewprofile`, payload, {
        headers,
      });

      const info = response.data?.Info?.[0];
      if (!info) return;
      console.log("BankName value:", info.BankName);
      setFormData({
        userName: info.NameOnCard || "",
        mobileNumber: info.MobileNumber || "",
        email: info.Poiemail || "",
        accountNumber: info.AccountNo || "",
        ifscCode: info.IFSCCode || "",
        bankName: info.IFSCCode || "",
        branchName: info.branchName || "",
        mmid: info.MMID || "",
        kycStatus: info.Is_KYC_Done || "",
        aadhaarStatus: info.aadhaarStatus || "Aadhaar submitted successfully",
      });
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  // Fetch profile details from API (name, email, mmid, bank name etc.)
  useEffect(() => {
    if (!ip) return;
    fetchProfile();
  }, [ip]);

  const handlehomenavigation = () => navigate("/profile-settings");

  /** Theme Colors **/
  const pageBg = isDark ? "#041027" : "#eef2f7";
  const cardBg = isDark ? "#0B1C30" : "#ffffff";
  const textColor = isDark ? "#d8e0eb" : "#1b1f27";

  return (
    <>
      <DashboardHeader />
      {/* TOP HEADER */}

      {/* <Divider
        sx={{
          my: 2,
          opacity: 1,
          width: { xs: "60%", sm: "75%", md: "85%", lg: "90%" },
          mx: "auto",
        }}
      /> */}

      {/* PAGE BODY */}
      <Box
        sx={{
          p: { xs: 2, md: 4 },
          backgroundColor: pageBg,
          display: "flex",
          justifyContent: "center",
        }}
      >
        {/* MAIN CARD */}
        <Card
          sx={{
            width: "100%",
            maxWidth: 1550,
            borderRadius: 4,
            backgroundColor: cardBg,
            border: isDark
              ? "1px solid rgba(90,126,173,0.45)"
              : "1px solid rgba(0,0,0,0.12)",
            boxShadow: isDark
              ? "0 0 15px rgba(0,0,0,0.4)"
              : "0 0 8px rgba(0,0,0,0.1)",
          }}
        >
          <CardContent sx={{ p: { xs: 2, md: 4 } }}>
            {/* --- TITLE + EDIT BTN --- */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 3,
                alignItems: "center",
              }}
            >
              <Typography
                variant="h5"
                fontWeight="bold"
                sx={{ color: textColor }}
              >
                Profile Information
              </Typography>
              <IconButton
                onClick={handlehomenavigation}
                sx={{ bgcolor: "white", color: "#1e5fd8" }}
              >
                <ArrowBackIosNewOutlined />
              </IconButton>
            </Box>
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
              <DialogTitle>Select Image</DialogTitle>

              <DialogActions
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  p: 2,
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    setOpenDialog(false);

                    setTimeout(() => {
                      setOpenCamera(true);
                    }, 200);
                  }}
                >
                  📷 Take Photo
                </Button>

                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() => {
                    setOpenDialog(false);

                    setTimeout(() => {
                      fileInputRef.current.click();
                    }, 100);
                  }}
                >
                  🖼 Choose Photo
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={openCamera}
              onClose={() => setOpenCamera(false)}
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle>Camera</DialogTitle>

              <DialogContent>
                {openCamera && (
                  <Webcam
                    ref={webcamRef}
                    audio={false}
                    mirrored
                    screenshotFormat="image/jpeg"
                    width="100%"
                    videoConstraints={{
                      facingMode: "user",
                    }}
                  />
                )}
              </DialogContent>

              <DialogActions>
                <Button onClick={() => setOpenCamera(false)}>Cancel</Button>

                <Button variant="contained" onClick={captureImage}>
                  Capture
                </Button>
              </DialogActions>
            </Dialog>

            {/* --- AVATAR --- */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                mb: 3,
              }}
            >
              <Avatar
                sx={{
                  width: 120,
                  height: 120,
                  mx: "auto",
                  mb: 1,
                  cursor: "pointer",
                  bgcolor: isDark ? "#17324b" : "#d3ddea",
                }}
                onClick={handleAvatarClick}
                src={image || "/Assets/camera_icon.png"}
              />

              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              <Typography variant="body2" color="textSecondary" align="center">
                Click on the image to upload or change your profile picture
              </Typography>
            </Box>

            {/* --- FIELDS GRID --- */}
            <Grid container spacing={3}>
              {[
                { label: "User Name", value: formData.userName },
                { label: "Mobile Number", value: formData.mobileNumber },
                { label: "Email", value: formData.email },
                { label: "Account Number", value: formData.accountNumber },
                { label: "IFSC Code", value: formData.ifscCode },
                { label: "Bank Name", value: formData.bankName },
                { label: "MMID", value: formData.mmid },
                {
                  label: "KYC Status",
                  value:
                    String(formData.kycStatus) === "1" ? "Full KYC" : "Low KYC",
                  icon: true,
                },
                {
                  label: "Aadhaar Status",
                  value: formData.aadhaarStatus,
                  icon: true,
                },
              ].map((field, i) => (
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  key={i}
                >
                  <Typography color="gray">{field.label}</Typography>

                  <TextField
                    fullWidth
                    value={field.value}
                    disabled
                    InputProps={{
                      readOnly: true,
                      startAdornment: field.icon && (
                        <InputAdornment position="start">
                          <CheckCircleIcon
                            sx={{ color: "#25D366", fontSize: 22 }}
                          />
                        </InputAdornment>
                      ),
                      sx: {
                        background: isDark ? "#0B1C30" : "#fff",
                        border: isDark
                          ? "1px solid rgba(90,126,173,0.49)"
                          : "1px solid rgba(0,0,0,0.2)",
                        borderRadius: 2,
                        color: isDark ? "#fff" : "#000",
                        fontWeight: 600,
                        height: 55,
                        "&.Mui-disabled": {
                          WebkitTextFillColor: isDark ? "#fff" : "#000",
                          opacity: 1,
                          background: isDark ? "#0b1c30" : "#fff",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      },
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
